export default {
    getCompanyList: (state) => {
        return state.companyList;
    },
    getCompanyListCount: (state) => {
        return state.companyListCount;
    },
    getCompanyMainFilter: (state) => {
        return state.companyFilter.main_filter;
    },
    getCompanyFilterFields: (state) => {
        return state.companyFilter.fields;
    },
    getCompanyModalOpen: (state) => {
        return state.companyModalOpen;
    },
    getModalVerifyCompanyFormOpen: (state) => {
        return state.modalVerifyCompanyFormOpen;
    },
    getCompanyIdAndCompanyIndex: (state) => {
        return {
            company_id: state.company_id,
            company_index: state.company_index
        };
    },
    getCompanyId: (state) => {
        return state.company_id;
    },
    getTopUpBalanceCompanyModalOpen: (state) => {
        return state.topUpBalanceCompanyModalOpen;
    },
    getBuySignaturesCompanyModalOpen: (state) => {
        return state.buySignaturesCompanyModalOpen;
    },
}
